import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getNotesApi, getProfileDetailAPi, postNotesApi, getProfileReviewsAPi, updateNotesApi, getConversationIDApi, removePrivateTalentAPI } from "../../API/API";

function* getProfileDetailsSaga(action) {
    try {
        const { id } = action.payload;
        const response = yield call(() => getProfileDetailAPi(id));
        yield put({ type: types.FETCH_PROFILE_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.FETCH_PROFILE_DETAILS_FAILURE, error });
    }
}

function* getProfileReviewsSaga(action) {
    try {
        const { id } = action.payload;
        const response = yield call(() => getProfileReviewsAPi(action.payload));
        yield put({ type: types.FETCH_PROFILE_REVIEWS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.FETCH_PROFILE_REVIEWS_FAILURE, error });
    }
}

function* postNotesSaga(action) {
    try {
        const response = yield call(() => postNotesApi(action.payload));
        yield put({ type: types.POST_NOTES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.POST_NOTES_FAILURE, error });
    }
}

function* getNotesSaga(action) {
    try {
        const response = yield call(() => getNotesApi(action.payload));
        yield put({ type: types.GET_NOTES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_NOTES_FAILURE, error });
    }
}

function* updateNotesSaga(action) {
    try {
        const response = yield call(() => updateNotesApi(action.payload));
        yield put({ type: types.UPDATES_NOTES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.UPDATES_NOTES_FAILURE, error });
    }
}

function* getConversationIdSaga(action) {
    try {
        const response = yield call(() => getConversationIDApi(action.payload));
        yield put({ type: types.GET_CONVERSATION_ID_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_CONVERSATION_ID_FAILURE, error });
    }
}

function* removePrivateTalentSaga(action) {
    try {
        const response = yield call(() => removePrivateTalentAPI(action.payload));
        yield put({ type: types.REMOVE_PRIVATE_MARKET_TALENT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.REMOVE_PRIVATE_MARKET_TALENT_FAILURE, error });
    }
}

export function* watchGetProfileDetails() {
    yield takeEvery(types.FETCH_PROFILE_DETAILS_REQUESTED, getProfileDetailsSaga);
}

export function* watchGetProfileReviews() {
    yield takeEvery(types.FETCH_PROFILE_REVIEWS_REQUESTED, getProfileReviewsSaga);
}

export function* watchPostNotesSaga() {
    yield takeEvery(types.POST_NOTES_REQUESTED, postNotesSaga);
}

export function* watchgetNotesSaga() {
    yield takeEvery(types.GET_NOTES_REQUESTED, getNotesSaga);
}

export function* watchUpdateNotesSaga() {
    yield takeEvery(types.UPDATES_NOTES_REQUESTED, updateNotesSaga);
}

export function* watchGetConversationIdSaga() {
    yield takeEvery(types.GET_CONVERSATION_ID_INIT, getConversationIdSaga);
}

export function* watchRemovePrivateTalentSaga() {
    yield takeEvery(types.REMOVE_PRIVATE_MARKET_TALENT, removePrivateTalentSaga);
}